import { MfsInternalSessionData, MfsDefinedValue, DataSetId, SessionDataId } from '../../volatileSession';

/** Possible types of signals */
export type MfsSignalType =
  | 'setDataSignal'
  | 'deleteDataSignal'
  | 'findClientsRequest'
  | 'findClientsResponse'
  | 'getSessionDataRequest'
  | 'getSessionDataResponse';

/** Session data map type */
export type SessionDataMapType = Map<DataSetId, Map<SessionDataId, MfsInternalSessionData>>;

export const mfsSignalType: Record<MfsSignalType, boolean> = {
  setDataSignal: true,
  deleteDataSignal: true,
  findClientsRequest: true,
  findClientsResponse: true,
  getSessionDataRequest: true,
  getSessionDataResponse: true,
};

/** Payload for all signals sent/received */
export type MfsSignalPayload = {
  senderAppId: string; // app ID of sender client
  data: MfsDefinedValue; // payload of the signal
  refSeqNumber: number; // sequence number of the signal
};

/** Payload for delete signals */
export type MfsDeleteSignalData = {
  dataSetId: string;
  sessionDataId?: string;
};

/** Payload for find clients response signal */
export type MfsFindClientsResponseData = {
  responderClientId: string;
};

/** Payload for get session data request signal */
export type MfsSessionDataRequest = {
  /** The buddy client's ID */
  targetClientId: string;
};

/** Payload for get session data response signal */
export type MfsSessionDataResponse = {
  /** The sesion data */
  internalSessionDataArray: MfsInternalSessionData[];
};

/** Payload for set signals */
export type MfsSetSignalData = MfsInternalSessionData;

/** Type for pending signals to send */
export type MfsPendingSignalToSend = {
  signalType: MfsSignalType;
  data: MfsDefinedValue;
};

/** Type for pending signals be recieved */
export type MfsPendingSignalToReceive = {
  signalType: MfsSignalType;
  payload: MfsSignalPayload;
};
